module.exports = __webpack_public_path__ + "img/default-btn-in.4fd2a99d.png";